(function (angular) {

    'use strict';

    angular.module('harriApp').controller('PhoneVerificationByEmployeeModal', PhoneVerificationByEmployeeModal);

    PhoneVerificationByEmployeeModal.$inject = ['$scope', '$q', 'modalData', 'hUser', 'onSave'];

    function PhoneVerificationByEmployeeModal($scope, $q, modalData, hUser, onSave) {
        var self = this;
        self.phone = modalData.phone;

        self.hideModal = function () {
            $scope.$hide();
        };

        self.handleValidation = function () {
            if (!self.code) {
                self.fieldIsEmpty = true;
            } else {
                self.fieldIsEmpty = false;
            }
            if(isNaN(self.code)) {
                self.isDigits = true;
            }
            else {
                self.isDigits = false;
            }
            self.invlaidCodeMsg= '';
        }

        self.save = function () {
            if (self.code) {
                self.isPending = true;
                self.fieldIsEmpty = false;
                UserAPI.verifyPhonebyEmployee('PHONE', self.code)
                    .then(function (res) {
                        onSave();
                        self.hideModal();
                    })
                    .catch(function (err) {
                        if (err.data.code == 'INVALID_VERIFICATION_CODE') {
                            self.invlaidCodeMsg = $filter("translate")("Invalid verification code");
                        }
                        if (err.data.code == 'EXPIRED_VERIFICATION_CODE') {
                            self.invlaidCodeMsg = $filter("translate")("Expired verification code");
                        }
                        if (err.data.code == 'VERIFICATION_CODE_NOT_REQUESTED') {
                            self.invlaidCodeMsg = $filter("translate")("Verification code is not requested");
                        }
                        if (err.data.code == 'USER_ALREADY_VERIFIED') {
                            self.invlaidCodeMsg = $filter("translate")("User is already verified");
                        }
                        console.error(err);
                    })
                    .finally(function () {
                        $scope.$digest();
                        self.isPending = false;
                    });
            } else {
                self.fieldIsEmpty = true;
            }

        }

        self.resendCode = function () {
            self.isPhonePending = true;

            UserAPI.sendVerificationLink('PHONE')
                .then(function () {
                })
                .catch(function (err) {
                    console.error(err);
                    if (err.status_code == 422) {
                        $scope.phoneVerifiedMessage = $filter("translate")('Phone is already verified');
                    }
                    if (err.status_code == 400) {
                        if (err.data.code === "USER_MAX_RETRIES_REACHED") {
                            $scope.phoneVerifiedMessage = $filter("translate")(err.data.message);
                        } else {
                            $scope.phoneVerifiedMessage = $filter("translate")('Phone is verified for another account');
                        }
                    }
                })
                .finally(function () {
                    $scope.$digest();
                    self.isPhonePending = false;
                });
        }

    }
})(angular);
